// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_NO_RELATED_ITEMS_FOUND = "Nena\u0161li sme \u017eiadne podobn\u00e9 inzer\u00e1ty.";
export const RELATED_BAZAAR_PRODUCTS = "Podobn\u00e9 inzer\u00e1ty";
